import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
export const apiSlice = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://priyoserver.herokuapp.com",
    }),
    tagTypes: ["todos", "todo", "TodosByColor"],
    endpoints: (builder) => ({
        getTodos: builder.query({
            query: () => `/todos`,
            keepUnusedDataFor: 600,
            providesTags: ["todos"],
        }),
        getTodosByColor: builder.query({
            query: (color) => `/todos?color=${color}`,
            keepUnusedDataFor: 600,
            providesTags: (result, error, arg) => [{ type: "TodosByColor", id: arg }],
        }),
       

        getTodo: builder.query({
            query: (id) => `/todos/${id}`,
        }),

       
        addTodo: builder.mutation({
            query: (data) => ({
                url: '/todos',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ["todos"],
        }),

        editTodo: builder.mutation({
            query: ({ id, data }) => ({
                url: `/todos/${id}`,
                method: "PATCH",
                body: data,
            }),
            invalidatesTags: ["todos"],
        }),
        completeAllTodos: builder.mutation({
            query: () => ({

            }),
        }),
        
        deleteTodo: builder.mutation({
            query: (id) => ({
                url: `/todos/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ["todos"],
        }),

    })
});

export const {
    useGetTodosQuery,
    useGetTodoQuery,
    useGetTodosByColorQuery,
   
    useAddTodoMutation,
    useEditTodoMutation,
    
    useDeleteTodoMutation
} = apiSlice;